import { Box, Stack, styled, Typography } from '@mui/material';

export const Container = styled(Stack)({
  gap: 24,
});

export const TextFieldsContainer = styled(Stack)({
  paddingBottom: 2,
  gap: 12,
});

export const DividerContainer = styled(Box)('');

export const Subtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography['body-2'],
  color: theme.palette.grey[500],
}));

export const Link = styled(Typography)(({ theme }) => ({
  ...theme.typography['body-2-md'],
  color: theme.palette.primary[700],

  '& span': {
    cursor: 'pointer',
  },
}));

export const LinkContainer = styled(Stack)({
  paddingTop: 6,
});

export const Block = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: 4,
});
